import { TypedDocumentNode, gql, useMutation } from '@apollo/client';
import { faDownToLine } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { LoadingButton } from '@sorare/core/src/atoms/buttons/LoadingButton';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { useSnackNotificationContext } from '@sorare/core/src/contexts/snackNotification';

import MyPage from '../MyPage';
import { TransactionsHistoryContent } from './TransactionsHistoryContent';
import {
  GenerateAccountingExtractMutation,
  GenerateAccountingExtractMutationVariables,
} from './__generated__/index.graphql';

const GENERATE_ACCOUNTING_EXTRACT_MUTATION = gql`
  mutation GenerateAccountingExtractMutation(
    $input: generateAccountingExtractInput!
  ) {
    generateAccountingExtract(input: $input) {
      errors {
        code
        message
        path
      }
    }
  }
` as TypedDocumentNode<
  GenerateAccountingExtractMutation,
  GenerateAccountingExtractMutationVariables
>;

type Props = {
  short?: boolean;
};

export const TransactionsHistory = ({ short }: Props) => {
  const { showNotification } = useSnackNotificationContext();

  const [generate, { loading }] = useMutation(
    GENERATE_ACCOUNTING_EXTRACT_MUTATION
  );

  const generateAccountExtract = () => {
    generate({
      variables: {
        input: {
          includeFiatEntries: true,
          includeCreditCardPayments: true,
          includeLostBids: true,
        },
      },
    }).then(({ data }) => {
      if (!data?.generateAccountingExtract?.errors.length) {
        showNotification('accountingExtractSent');
      }
    });
  };

  return (
    <MyPage
      toolbar={
        <LoadingButton
          color="tertiary"
          size="small"
          startIcon={<FontAwesomeIcon icon={faDownToLine} />}
          onClick={generateAccountExtract}
          loading={loading}
        >
          <FormattedMessage
            id="MySorare.TransactionsHistory.downloadCSV"
            defaultMessage="Download CSV"
          />
        </LoadingButton>
      }
    >
      <TransactionsHistoryContent short={short} />
    </MyPage>
  );
};

export default TransactionsHistory;
